var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.75 4h1.375l-5.823 6.776L19.625 20h-4.656l-4.257-6.21L5.375 20H4l6.102-7.1L4 4h4.656l4.035 5.886zm-2.092 15h1.906l-5.027-7.334-1.06 1.234zm-4.792-6.99L6.061 5h1.906l3.96 5.776z",
    clipRule: "evenodd"
  })));
};
export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3Ljc1IDRIMTkuMTI1TDEzLjMwMTcgMTAuNzc2MkwxOS42MjUgMjBIMTQuOTY4N0wxMC43MTE2IDEzLjc5MDFMNS4zNzUgMjBINEwxMC4xMDE1IDEyLjkwMDFMNCA0SDguNjU2MjVMMTIuNjkxNSA5Ljg4NjIyTDE3Ljc1IDRaTTE1LjY1ODIgMTlIMTcuNTY0NUwxMi41MzY4IDExLjY2NjJMMTEuNDc2NSAxMi45MDAxTDE1LjY1ODIgMTlaTTEwLjg2NjMgMTIuMDEwMUw2LjA2MDU1IDVINy45NjY4TDExLjkyNjcgMTAuNzc2MkwxMC44NjYzIDEyLjAxMDFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4=";